<div class="date-picker-container" [style.justify-content]="justify">

  <div class="frequency-select-L" *ngIf="isFrequency && layout === 'lefty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="frequencyAppearance"
        style="--padding: {{frequencyAppearance === 'outline' ? '0' : '1.25rem'}}"
        [ngClass]="isDarkTheme ? 'mat-select-value-dark' : 'mat-select-value-dark'">
        <mat-select [formControl]="frequencyControl" (selectionChange)="changeFrequency($event.value)"
          [ngClass]="isDarkTheme ? 'mat-select-value-dark' : 'mat-select-value-light'">
          <!-- <mat-option value="daily">
            {{'DATA_XP.daily' | translate}}
          </mat-option>
          <mat-option value="weekly">
            {{'DATA_XP.weekly' | translate}}
          </mat-option>
          <mat-option value="monthly">
            {{'DATA_XP.monthly' | translate}}
          </mat-option>
          <mat-option value="yerly">
            {{'DATA_XP.yearly' | translate}}
          </mat-option>
          <mat-option value="personalized">
            {{'DATA_XP.personalized' | translate}}
          </mat-option> -->
          <mat-option *ngFor="let frequency of frequenciesList" [value]="frequency"
            [ngClass]="isDarkTheme ? 'mat-select-value-dark' : 'mat-select-value-dark'">
            {{ frequency | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <ng-container *ngTemplateOutlet="entity"></ng-container>
  </div>

  <div class="frequency-select-L" *ngIf="isAggregation && layout === 'lefty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="frequencyAppearance"
        style="--padding: {{frequencyAppearance === 'outline' ? '0' : '1.25rem'}}">
        <mat-select [formControl]="aggregationControl" (selectionChange)="changeAggregation($event.value)"
          [placeholder]="aggregationPlaceholder"
          [ngClass]="isDarkTheme ? 'mat-select-value-dark' : 'mat-select-value-light'">
          <mat-option *ngFor="let aggregation of aggregationList" [value]="aggregation">
            {{ aggregation | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>


  <div class="date-select">
    <button mat-icon-button color="primary" (click)="changeDate(-1)" [disabled]="!canChangeWith(-1) || !choiceSet">
      <mat-icon svgIcon="arrow_left"></mat-icon>
    </button>

    <div class="date-label" [style.color]="isDarkTheme ? '#FFFFFF' : '#000000'">{{ getCurrentDate() }}</div>

    <button mat-icon-button color="primary" (click)="changeDate(1)" [disabled]="!canChangeWith(1) || !choiceSet">
      <mat-icon svgIcon="arrow_right"></mat-icon>
    </button>

    <button mat-icon-button color="primary" (click)="choiceSet ? picker.open() : pickerRange.open()">
      <mat-icon svgIcon="calendar"></mat-icon>
    </button>
    <!--The real date picker input field is hidden and is controlled by the arrows and button-->
    <mat-form-field class="hidden-input">
      <input matInput [formControl]="dateControl" [min]="min" [max]="max" [matDatepicker]="picker"
        (dateChange)="changeDate($event)" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker [startView]="frequencyView()"></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="hidden-input">
      <mat-date-range-input [formGroup]="rangeControl" [rangePicker]="pickerRange">
        <input matStartDate formControlName="start">
        <input matEndDate formControlName="end">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
      <mat-date-range-picker #pickerRange (closed)="setDate($event)"></mat-date-range-picker>

      <mat-error *ngIf="rangeControl.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
      <mat-error *ngIf="rangeControl.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
    </mat-form-field>
  </div>

  <div class="frequency-select-R" *ngIf="isFrequency && layout === 'righty'">
    <ng-container *ngTemplateOutlet="entity"></ng-container>
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="frequencyAppearance">
        <mat-select [formControl]="frequencyControl" (selectionChange)="changeDate($event.value)"
          [ngClass]="isDarkTheme ? 'mat-select-value-dark' : 'mat-select-value-light'">
          <mat-option *ngFor="let frequency of frequenciesList" [value]="frequency">
            {{ frequency | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="frequency-select-R" *ngIf="isAggregation && layout === 'righty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="frequencyAppearance"
        style="--padding: {{frequencyAppearance === 'outline' ? '0' : '1.25rem'}}">
        <mat-select [formControl]="aggregationControl" (selectionChange)="changeAggregation($event.value)"
          [placeholder]="aggregationPlaceholder"
          [ngClass]="isDarkTheme ? 'mat-select-value-dark' : 'mat-select-value-light'">
          <mat-option *ngFor="let aggregation of aggregationList" [value]="aggregation">
            {{ aggregation | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>

<ng-template #entity><ng-content></ng-content></ng-template>